/**
 * Created by razial on 19.12.2024.
 */

PassLevelsConfig.expeditionpass = [
    {
        task: {
            goal: 30
        },
        reward: {
            unit: { code: "worker", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "worker", stage: 1, amount: 1 }
        }
    }, // 1
    {
        task: {
            goal: 60
        },
        reward: {
            unit: { code: "sacks", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 1, amount: 1 }
        }
    }, // 2
    {
        task: {
            goal: 100
        },
        reward: {
            unit: { code: "wands", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "wands", stage: 2, amount: 1 }
        }
    }, // 3
    {
        task: {
            goal: 250
        },
        reward: {
            unit: { code: "coins", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "rubies", stage: 3, amount: 1 }
        }
    }, // 4
    {
        task: {
            goal: 500
        },
        reward: {
            unit: { code: "crystal", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 1, amount: 3 }
        }
    }, // 5
    {
        task: {
            goal: 1200
        },
        reward: {
            unit: { code: "treasure", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 2, amount: 1 }
        }
    }, // 6
    {
        task: {
            goal: 1500
        },
        reward: {
            unit: { code: "sacks", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 2, amount: 1 }
        }
    }, // 7
    {
        task: {
            goal: 1800
        },
        reward: {
            unit: { code: "herochest", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 1, amount: 2 }
        }
    }, // 8
    {
        task: {
            goal: 2000
        },
        reward: {
            unit: { code: "coins", stage: 3, amount: 1 }
        },
        premiumReward: {
            unit: { code: "rubies", stage: 3, amount: 2 }
        }
    }, // 9
    {
        task: {
            goal: 2600
        },
        reward: {
            unit: { code: "herochest", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "worker", stage: 3, amount: 3 }
        }
    }, // 10
    {
        task: {
            goal: 3300
        },
        reward: {
            unit: { code: "worker", stage: 3, amount: 1 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 2, amount: 1 }
        }
    }, // 11
    {
        task: {
            goal: 4000
        },
        reward: {
            unit: { code: "magicplant", stage: 3, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 2, amount: 3 }
        }
    }, // 12
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "sacks", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "magicplant", stage: 6, amount: 1 }
        }
    }, // 13
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "worker", stage: 3, amount: 1 }
        },
        premiumReward: {
            unit: { code: "worker", stage: 4, amount: 2 }
        }
    }, // 14
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "herochest", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 2, amount: 2 }
        }
    }, // 15
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "wands", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "wands", stage: 3, amount: 3 }
        }
    }, // 16
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "coins", stage: 3, amount: 2 }
        },
        premiumReward: {
            unit: { code: "rubies", stage: 4, amount: 1 }
        }
    }, // 17
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "treasure", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 2, amount: 3 }
        }
    }, // 18
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "crystal", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 3, amount: 2 }
        }
    }, // 19
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "sacks", stage: 2, amount: 2 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 2, amount: 3 }
        }
    }, // 20
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "coins", stage: 4, amount: 3 }
        },
        premiumReward: {
            unit: { code: "rubies", stage: 4, amount: 3 }
        }
    }, // 21
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "herochest", stage: 1, amount: 2 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 3, amount: 3 }
        }
    }, // 22
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "worker", stage: 4, amount: 1 }
        },
        premiumReward: {
            unit: { code: "magicplant", stage: 7, amount: 1 }
        }
    }, // 23
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "magicplant", stage: 4, amount: 1 }
        },
        premiumReward: {
            unit: { code: "coinstree", stage: 3, amount: 1 }
        }
    }, // 24
    {
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "magicplant", stage: 5, amount: 1 }
        },
        premiumReward: {
            unit: { code: "energytree", stage: 3, amount: 1 }
        }
    }// 25
];

PassLevelsConfig.difficultexpeditionpass = cleverapps.clone(PassLevelsConfig.expeditionpass, true);
PassLevelsConfig.difficultexpeditionpass.forEach((level) => {
    level.task.goal *= 3;
});
